












import G01ContentButtonList from "@/general/components/pages/parts/Ranking/G01ContentButtonList.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    G01ContentButtonList
  }
})
export default class TheG01Content extends Vue {
  @Prop({ type: Array, required: true, default: () => [] }) categories!: any;
  @Prop({ type: Boolean, required: true, default: true }) isCategory!: boolean;
}
